import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { map, Observable } from 'rxjs';
import { TranslationConfig } from './translation.types';
import { FetcherService } from '@cpak/main-features-lib/services';

@Injectable({
  providedIn: 'root',
})
export class TranslationRepositoryService implements TranslocoLoader {
  constructor(private fetcher: FetcherService) {}

  public getTranslationConfig(): Observable<TranslationConfig | null> {
    return this.fetcher.get<TranslationConfig>(`/translations/translations.config.json`);
  }

  public getTranslation(culture: string): Observable<Translation> | Promise<Translation> {
    return this.fetcher
      .get<{ Key: string; Translation: string }[]>(`/translations/${culture}.json`)
      .pipe(map(translations => Object.fromEntries(translations?.map(e => [e.Key, e.Translation]) || [])));
  }
}
